import * as Yup from 'yup'

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  description: Yup.string().nullable(),
  price: Yup.number().typeError("Campo requerido").required("Campo requerido").min(0, "El valor debe ser mayor o igual a 0").max(100000, "El valor debe ser menor o igual a 100000"),
  calories: Yup.number().typeError("Campo requerido").min(0, "El valor debe ser mayor o igual a 0").max(100000, "El valor debe ser menor o igual a 100000"),
  portions: Yup.number().typeError("Campo requerido").min(0, "El valor debe ser mayor o igual a 0").max(100, "El valor debe ser menor o igual a 100"),
  preparation_time: Yup.number().typeError("Campo requerido").min(0, "El valor debe ser mayor o igual a 0").max(100, "El valor debe ser menor o igual a 100"),
  image: Yup.mixed().when('showImage', {
    is: true,
    then: Yup.mixed()
      .test("type", "Solo imagenes", (value) => {
        console.log("Validation imageActive", value)
        if (value === "" || value === null || value === undefined) {
          console.log("Validation imageActive 1", value)
          return true
        }
        var regex = /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/;
        if (regex.test(value)) {
          return true
        }
        return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")

      }),
    otherwise: Yup.mixed().nullable()
  }),
  video: Yup.string().when('showVideo', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  subcategory: Yup.string().required("Campo requerido"),
  showImage: Yup.boolean().nullable(),
  showVideo: Yup.boolean().nullable(),
  active: Yup.boolean().required("Campo requerido"),
})

// Variants Validations
export const ValidationSchemaVariant = Yup.object().shape({
  name: Yup.string().required("Campo requerido"),
  description: Yup.string().nullable(),
  price: Yup.number().typeError("Campo debe ser numérico").required("Campo requerido"),
  image: Yup.string().when('showImage', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  video: Yup.string().when('showVideo', {
    is: true,
    then: Yup.string().required("Campo requerido"),
    otherwise: Yup.string().nullable()
  }),
  calories: Yup.number().typeError("Campo debe ser numérico"),
  showName: Yup.boolean().nullable(),
  showImage: Yup.boolean().nullable(),
  showVideo: Yup.boolean().nullable(),
  active: Yup.boolean().required("Campo requerido"),
})

export const ValidationSchemaVariants = Yup.object({
  variants: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Campo requerido"),
      description: Yup.string().nullable(),
      price: Yup.number().typeError("Campo debe ser numérico").required("Campo requerido"),
      image: Yup.string().when('showImage', {
        is: true,
        then: Yup.string().required("Campo requerido"),
        otherwise: Yup.string().nullable()
      }),
      video: Yup.string().when('showVideo', {
        is: true,
        then: Yup.string().required("Campo requerido"),
        otherwise: Yup.string().nullable()
      }),
      calories: Yup.number().typeError("Campo debe ser numérico"),
      showName: Yup.boolean().nullable(),
      showImage: Yup.boolean().nullable(),
      showVideo: Yup.boolean().nullable(),
      active: Yup.boolean().required("Campo requerido"),
    })
  )
})